/** Os formatos e o texto fixo da peça impressa do link de cadastro (T37). */

export type PieceFormat = 'a4' | 'a5' | 'a6'

export const PIECE_FORMATS: {
  value: PieceFormat
  label: string
  /** O `size` do `@page` na impressão. */
  page: string
  /** A folha por extenso, para a nota da prévia. */
  sheet: string
}[] = [
  { value: 'a4', label: 'Cartaz A4', page: 'A4 portrait', sheet: 'folha A4' },
  { value: 'a5', label: 'Meia folha A5', page: 'A5 portrait', sheet: 'meia folha (A5)' },
  { value: 'a6', label: 'Cartão A6', page: 'A6 portrait', sheet: 'cartão (A6)' },
]

export const PIECE_STEPS = [
  'Aponte a câmera',
  'Preencha em dois minutos',
  'Chegue com tudo pronto',
] as const
